import { useContext } from "react";
import UIContext from './UIStackContext';
export function useUIStack() {
    return useContext(UIContext);
}
//# sourceMappingURL=useUIStack.js.map